module.exports = __webpack_public_path__ + "static/media/loc4_img1.97bad5de.jpg";